import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useSearchParams } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [status, setStatus] = useState('checking'); // checking | ok | error
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setErr('Ссылка неверна — в ней нет токена.'); return; }
    axios.post(`${API}/auth/email-verify`, { token })
      .then(() => setStatus('ok'))
      .catch(e => { setStatus('error'); setErr(e?.response?.data?.detail || 'Не удалось подтвердить email'); });
  }, [token]);

  return (
    <div style={s.page}>
      <div style={s.card}>
        <img src="/refero-logo-vert.svg" alt="Réfero" style={s.logoImg} />
        <div style={s.logoSub}>кабинет врача</div>
        <h2 style={s.title}>Подтверждение email</h2>
        {status === 'checking' && <div style={s.muted}>Проверяем ссылку…</div>}
        {status === 'ok' && <div style={s.sentText}>Email подтверждён. Спасибо!</div>}
        {status === 'error' && <div style={s.err}>{err}</div>}
        <div style={s.links}>
          <Link to={localStorage.getItem('token') ? '/dashboard' : '/login'} style={s.link}>
            {localStorage.getItem('token') ? 'Перейти в кабинет' : 'Войти в кабинет'}
          </Link>
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F6F8FB', fontFamily: 'Inter, system-ui, sans-serif', padding: 20, boxSizing: 'border-box' },
  card: { background: '#fff', borderRadius: 16, padding: 36, width: '100%', maxWidth: 380, boxSizing: 'border-box', boxShadow: '0 8px 30px rgba(27,43,75,0.08)', textAlign: 'center' },
  logoImg: { width: 150, height: 'auto', display: 'block', margin: '0 auto 6px' },
  logoSub: { color: '#2EC4B6', fontSize: 13, fontWeight: 600, textAlign: 'center', marginBottom: 8 },
  title: { color: '#1B2B4B', fontSize: 18, fontWeight: 600, margin: '8px 0 20px' },
  muted: { color: '#64748b', fontSize: 14 },
  sentText: { color: '#334155', fontSize: 14, lineHeight: 1.5, background: '#f0fdfa', border: '1px solid #99f6e4', borderRadius: 10, padding: '14px 16px' },
  err: { color: '#ef4444', fontSize: 13 },
  links: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, marginTop: 18 },
  link: { color: '#2EC4B6', textAlign: 'center', fontSize: 13, textDecoration: 'none', fontWeight: 500 },
};
